export default "__VITE_ASSET__Bui0dimo__"